import { defineStore } from 'pinia'
import type { Me } from '@/api/contract'
import { fetchMe } from '@/api/reports'
import { useKeycloak } from '@/plugins/keycloak'

export type Role = Me['roles'][number]

export const useAuth = defineStore('auth', {
    state: () => ({ me: null as Me | null }),
    getters: {
        roles: (state): Role[] => state.me?.roles ?? [],
    },
    actions: {
        hasRole(role: Role): boolean {
            return this.roles.includes(role)
        },
        async load() {
            this.me = await fetchMe(useKeycloak())
        },
        async logout() {
            await useKeycloak().logout({ redirectUri: window.location.origin, logoutMethod: 'POST' })
        },
    },
})
